import React, { useEffect, useState } from 'react';

import ReplaceOperator from '../../Components/ReplaceOperator';
import ModalWarn from '../../Components/Modal/Warn/index'

export default function ReplaceAgencyManager(props) {
    const [ agencyManager, setAgencyManager ] = useState({
        id_usuario_orgao: '',
        cpf: '',
        name: '',
        organ: '',
        dt_inc: '',
        dt_canc_exp: ''
    });
    const [ agencyManagerSubstitute, setAgencyManagerSubstitute ] = useState({
        id_usuario_orgao: '',
        cpf: '',
        name: '',
        organ: '',
        dt_inc: '',
        dt_canc_exp: ''
    });
    const [ loadAgencyManager, setLoadAgencyManager ] = useState(false);
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    useEffect(() => {
        if (!loadAgencyManager && props.location.state !== undefined) {
            setAgencyManager({
                id_usuario_orgao: props.location.state.agency_manager.id_usuario_orgao,
                cpf: props.location.state.agency_manager.cpf,
                name: props.location.state.agency_manager.name,
                organ: props.location.state.agency_manager.organ,
                dt_inc: props.location.state.agency_manager.dt_inc,
                dt_canc_exp: props.location.state.agency_manager.dt_canc_exp
            });
            setAgencyManagerSubstitute({
                id_usuario_orgao: props.location.state.agency_manager_substitute.id_usuario_orgao,
                cpf: props.location.state.agency_manager_substitute.cpf,
                name: props.location.state.agency_manager_substitute.name,
                organ: props.location.state.agency_manager_substitute.organ,
                dt_inc: props.location.state.agency_manager_substitute.dt_inc,
                dt_canc_exp: props.location.state.agency_manager_substitute.dt_canc_exp
            })

            setLoadAgencyManager(true);
        }
    }, [props, loadAgencyManager]);

    const [ successMsg, setSuccessMsg ] = useState("");
    const [ replaced, setReplaced ] = useState(false);
    const [ loadingCancel, setLoadingCancel ] = useState(false);
    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");

    const onSubmitReplace = async () => {

        setLoadingCancel(true);

        const requestOptions = {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",
                cpf_gestor_orgao: agencyManager.cpf,
                codigo_orgao: agencyManager.organ.value,
                id_usuario_orgao: agencyManager.id_usuario_orgao,
                cpf_gestor_orgao_substituto: agencyManagerSubstitute.cpf
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/substituiGestorOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function() {                    
                    setReplaced(true);
                    setLoadingCancel(false);
                    setSuccessMsg("Gestor de órgão/entidade substituído com sucesso.")
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setMessageError(data.message);
                        setModalError(true);
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                        console.log('Response error in /gestao/substituiGestorOrgao BackendBalcao');
                    }

                    setLoadingCancel(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingCancel(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingCancel(false);
                console.log('Error request to /gestao/substituiGestorOrgao');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <ReplaceOperator
                pageTitle='Substituir gestor de rede de atendimento'
                titleReplaced='Gestor de rede de atendimento a ser substituído'
                replacedOperator={agencyManager}
                titleReplacer='Gestor de rede de atendimento substituto'
                replacerOperator={agencyManagerSubstitute}
                loadOperator={loadAgencyManager}
                onSubmitReplace={onSubmitReplace}
                history={props.history}
                buttonBackRoute='/consultaGestorOrgaoSubstituto'
                buttonStartRoute='/pesquisarcidadao'
                successMsg={successMsg}
                replaced={replaced}
                loadingCancel={loadingCancel}
                modalError={modalError}
                setModalError={setModalError}
                messageError={messageError}
            />
        </>
    );
}